import axios from "axios";
import { saveAs } from "file-saver";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

let tokenGetter = async () => null;
export const setTokenGetter = (fn) => {
  tokenGetter = fn;
};

http.interceptors.request.use(async (config) => {
  const token = await tokenGetter();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const strip = (c) => ({ ...c, cover: { ...c.cover, image: null }, products: c.products.map((p) => ({ ...p, image: null })) });

export const fetchMe = () => http.get("/me").then((r) => r.data);
export const saveProfile = (profile) => http.put("/me/profile", profile).then((r) => r.data);
export const fetchCatalog = () => http.get("/catalog").then((r) => r.data);
export const saveCatalog = (catalog) => http.put("/catalog", strip(catalog));
export const uploadImage = (key, data) => http.put(`/images/${key}`, { data });
export const removeImage = (key) => http.delete(`/images/${key}`);
export const fetchUsers = () => http.get("/users").then((r) => r.data);
export const fetchInvites = () => http.get("/invitations").then((r) => r.data);
export const sendInvite = (email) => http.post("/invitations", { email, redirect_url: window.location.origin }).then((r) => r.data);
export const revokeInvite = (id) => http.post(`/invitations/${id}/revoke`);
export const logEvent = (type) => http.post("/events", { type }).catch(() => {});
export const fetchStats = () => http.get("/stats").then((r) => r.data);
export const fetchReportInfo = () => http.get("/reports/weekly/info").then((r) => r.data);
export const sendReportNow = () => http.post("/reports/weekly/send").then((r) => r.data);
export const fetchLinkStats = () => http.get("/link-stats").then((r) => r.data);
export const createOffer = (body) => http.post("/offers", body).then((r) => r.data);
export const fetchInterested = () => http.get("/offers/interested").then((r) => r.data);
export const resolveOffer = (id) => http.post(`/offers/${id}/resolve`);
export const fetchInsights = (agent) => http.get("/insights", { params: agent ? { agent } : {} }).then((r) => r.data);
export const setUserRole = (id, role) => http.patch(`/users/${id}/role`, { role });

export const downloadPdf = async () => {
  const r = await http.get("/catalog/pdf", { responseType: "blob" });
  saveAs(r.data, "Medavita_Bond_Elisier_Lista_Preturi.pdf");
};
